import { FC, useRef } from 'react';

import { Box, IconButton, Tooltip, useDisclosure } from '@chakra-ui/react';
import { FaQuestion } from 'react-icons/fa';
import { useIntl } from 'react-intl';

import { useMicrositeConfig } from '~/components/Site/provider/MicrositeConfigProvider';
import SupportModal from '~/components/Support/SupportModal';

const SupportButton: FC = ({ ...props }) => {
    const { event } = useMicrositeConfig();
    const nodeRef = useRef(null);
    const { isOpen, onClose, onOpen } = useDisclosure();
    const intl = useIntl();

    // Special handling for "Sonder-Academy on Health Care Policy" event
    if (event?.id === '4e582d99-b084-415e-9710-f25171b0d8cc') {
        return null;
    }

    const buttonLabel = intl.formatMessage({
        id: 'nav.main.support.hover',
        defaultMessage: 'Support-Anfrage'
    });

    return (
        <>
            <SupportModal isOpen={isOpen} onClose={onClose} />
            <Box ref={nodeRef}>
                <Tooltip label={buttonLabel} fontSize="md" hasArrow placement="left">
                    <IconButton
                        aria-label={buttonLabel}
                        icon={<FaQuestion />}
                        size="xl"
                        h="40px"
                        w="40px"
                        fontSize="2xl"
                        isRound={true}
                        colorScheme="brand"
                        variant="outline"
                        borderWidth="3px"
                        onClick={() => onOpen()}
                        {...props}
                    />
                </Tooltip>
            </Box>
        </>
    );
};

export default SupportButton;
